import useToggle from '../../Hooks/useToggle';
import Drawer from '../Mobile/DrawerLearn';
import Header from '../Helper/HeaderLearn';
import Footer from '../Helper/FooterInstitute';
import HomeMain from './HomeMain';
import ContactIconFooter from '../Helper/ContactIconFooter';

function DocLearn() {
    const [drawer, drawerAction] = useToggle(false);
    return (
        <>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <Header action={drawerAction.toggle} />
            <HomeMain />
            <Footer />
            <ContactIconFooter />
            {/* <BackToTop /> */}
        </>
    );
}

export default DocLearn;
